"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var RatingDetailsCondensed = function RatingDetailsCondensed(_ref) {
  var ratingDetails = _ref.ratingDetails,
    customClass = _ref.customClass,
    customId = _ref.customId,
    maxWidth = _ref.maxWidth,
    ratingFontSize = _ref.ratingFontSize,
    starSize = _ref.starSize;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: customId,
    className: "Ratings-Details-Condensed ".concat(customClass)
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Grid, {
    style: {
      maxWidth: maxWidth
    }
  }, (0, _map["default"])(ratingDetails).call(ratingDetails, function (ratingDetail) {
    return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
      key: ratingDetail.ratingName
    }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
      xs: 6
    }, ratingDetail.ratingName, /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
      xs: 6
    }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplay, {
      key: "rating-display-".concat(ratingDetail.ratingName),
      ratingLocation: "right",
      rating: ratingDetail.ratingValue,
      starSize: starSize,
      ratingFontSize: ratingFontSize
    })));
  })));
};
RatingDetailsCondensed.propTypes = {
  ratingDetails: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    ratingName: _propTypes["default"].string,
    ratingValue: _propTypes["default"].number
  })),
  customClass: _propTypes["default"].string,
  customId: _propTypes["default"].string,
  maxWidth: _propTypes["default"].string,
  ratingFontSize: _propTypes["default"].string,
  starSize: _propTypes["default"].string
};
RatingDetailsCondensed.defaultProps = {
  ratingDetails: [],
  customClass: '',
  customId: 'Ratings-Details-Condensed-Container',
  maxWidth: '',
  ratingFontSize: '1em',
  starSize: '1em'
};
var _default = exports["default"] = RatingDetailsCondensed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/ratings/ratingDetailsCondensed.js
// module id = 6250
// module chunks = 25